/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcRouteV1FixOrderEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ROUTE_V1_FIX_ORDER_EVENT_ENTITY_NAME = 'exc.route.v1.FixOrderEvent';
export const excRouteV1FixOrderEventEntity = new schema.Entity<ExcRouteV1FixOrderEvent>(EXC_ROUTE_V1_FIX_ORDER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcRouteV1FixOrderEvent) => `${entity.metadata?.eventId}` });

